import { Box } from "@mui/material";
import { memo, useMemo } from "react";
import { GrillaLiquidacionesPaciente } from "../../PreLiquidacion/components/GrillaLiquidacionesPaciente";
import { PreLiquidacionInfoProfesional } from "../../PreLiquidacion/components/PreLiquidacionInfoProfesional";

const LiquidacionFinalGrillaPorProfesionalBase = ({
    idProfesionalLiquidacion,
    liquidaciones,
    profesionalData,
    columns,
    mesLiquidado,
    allowedWrite,
    seleccionados,
    seleccionarTodos
}) => {
    const totalValue = useMemo(
        () => liquidaciones.reduce((total, l) => total + (l?.liquidacionTotal || 0), 0),
        [liquidaciones]
    );

    return (
        <Box>
            <Box sx={{ mb: 2 }}>
                <PreLiquidacionInfoProfesional
                    profesional={profesionalData}
                    mesLiquidado={mesLiquidado}
                    observacionRechazo={profesionalData.observacionRechazo}
                    liquidacionMesAnterior={liquidaciones[0]?.liquidacionTotalMesAnterior}
                />
            </Box>

            {liquidaciones.length > 0 ? (
                <GrillaLiquidacionesPaciente
                    columns={columns}
                    rows={liquidaciones}
                    totalValue={totalValue}
                    totalLabel='Total'
                />
            ) : (
                <Box sx={{ p: 2, textAlign: 'center', color: '#999' }}>
                    No hay liquidaciones disponibles
                </Box>
            )}
        </Box>
    );
};

export const LiquidacionFinalGrillaPorProfesional = memo(LiquidacionFinalGrillaPorProfesionalBase);